import { PlatformCatalogSortByParam, UsersSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: PlatformCatalogSortByParam.NAME_ASC,
    dataGridSortModel: {
      field: "name",
      sort: "asc",
    },
  },
  {
    backendString: PlatformCatalogSortByParam.NAME_DESC,
    dataGridSortModel: {
      field: "name",
      sort: "desc",
    },
  },
  {
    backendString: UsersSortByParam.UPDATED_AT_ASC,
    dataGridSortModel: {
      field: "updatedAt",
      sort: "asc",
    },
  },
  {
    backendString: UsersSortByParam.UPDATED_AT_DESC,
    dataGridSortModel: {
      field: "updatedAt",
      sort: "desc",
    },
  },
];

export const useCatalogsSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
